import React, { forwardRef, RefObject } from 'react';

import { SearchInput } from './components/SearchInput';
import styles from './search-block.module.scss';

export type SearchBlockProps = {
  toggleOverlay?: (value: 'on' | 'off') => void;
  topBlock?: boolean;
  topBlockActive?: boolean;
  onBlur?: () => void;
};

export const SearchBlock = forwardRef(
  ({ topBlock, toggleOverlay, topBlockActive, onBlur }: SearchBlockProps, ref: RefObject<HTMLInputElement>) => {
    const handleOverlayClick = () => {
      if (toggleOverlay) toggleOverlay('on');
    };

    const handleBlur = () => {
      onBlur && onBlur();
      toggleOverlay('off');
    };

    return (
      <div className={styles.topWrapper} onClick={handleOverlayClick}>
        <SearchInput
          topBlock={topBlock}
          menuBlock={!topBlock}
          topBlockActive={topBlockActive}
          toggleOverlay={toggleOverlay}
          handleBlur={handleBlur}
          ref={ref}
        />
      </div>
    );
  },
);

SearchBlock.displayName = 'SearchBlock';
